/**
 * 分支选择项
 */
export const BranchDs = [
  { label: "门户系统", value: "portal" },
  { label: "主分支", value: "main" },
]

/**
 * 状态选择项
 */
export const StatusDs = [
  { label: "启用", value: 0 },
  { label: "禁用", value: 1 },
]

/**
 * 性别选择项
 */
export const GenderDs = [
  { label: "女", value: 2 },
  { label: "男", value: 1 },
]

/**
 * 消息通知接收范围
 */
export const ReceiverTypeDs = [
  { label: "全部", value: 'ALL'},
  { label: "部门", value: 'ORG'},
  { label: "指定用户", value: 'USER'},
]